<template>
  <div v-show="!loading">
    <MembershipPaymentForm
      :run-confirm-card-setup="runPaymentSetup"
      @loaded="loading = false"
    />
    <button
      type="button"
      class="btn"
      @click="submit"
      v-text="'Submit'"
    />
  </div>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'
import MembershipPaymentForm from 'Payments/Resources/assets/js/components/MembershipFeePaymentForm'

export default {
  name: 'PaymentForm',
  components: {
    MembershipPaymentForm,
  },
  data() {
    return {
      loading: true,
      runPaymentSetup: false,
      setup_intent: {},
    }
  },
  methods: {
    ...mapActions([
      'paymentsSubmitMembershipFee',
    ]),
    submit() {
      if (!this.setup_intent.length) {
        this.runPaymentSetup = true
      } else {
        this.paymentsSubmitMembershipFee({
          setup_intent: this.setup_intent,
        })
      }
    },
    handleCardSetupConfirmed(data) {
      this.setup_intent = data.setupIntent
    },
    handleCardSetupError() {
      this.runPaymentSetup = false
    },
  },
}
</script>

<style scoped>
.field {
  width: 100%;
  border-radius: .25rem;
  padding-left: .5rem;
  padding-right: .5rem;
  padding-top: .75rem;
  padding-bottom: .75rem;
  margin-bottom: 1.5rem;
  font-size: .875rem;
  border-width: 1px;
  border-color: #afb2b3
}
</style>
